import { ROOT_URL } from "@/data/constants";
import fetcher from "@/data/fetcher";

const ACCESS_TOKEN_KEY = "@APP_ACCESS_TOKEN";
const REFRESH_TOKEN_KEY = "@APP_REFRESH_TOKEN";
const USER_ID_KEY = "@APP_USER_ID";
const USER_EMAIL_KEY = "@APP_USER_EMAIL";
const USER_FIRST_NAME_KEY = "@APP_USER_FIRST_NAME";
const USER_LAST_NAME_KEY = "@APP_USER_LAST_NAME";

const _getBaseURL = () => {
  return ROOT_URL;
}

const _getApiURL = () => {
  return "api/v1";
}

class AuthenticationAPI {
  static baseURL = _getBaseURL();
  static apiURL = _getApiURL();

  static userMeURL = `${this.baseURL}/${this.apiURL}/core/user/me/`;
  static userCreateURL = `${this.baseURL}/${this.apiURL}/core/user/create/`;
  static refreshURL = `${this.baseURL}/${this.apiURL}/api/token/refresh/`;
  static verifyURL = `${this.baseURL}/${this.apiURL}/api/token/verify/`;
  static authenticationURL = `${this.baseURL}/api/token/`;
  static loginWithCodeURL = `${this.baseURL}/${this.apiURL}/core/user/login-with-code/`;

  static async authenticate(payload) {
    const response = await fetcher(this.authenticationURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    const accessToken = data.access;
    const refreshToken = data.refresh;
    this.setRefreshToken(refreshToken);
    this.setAccessToken(accessToken);
    return { data, response };
  }

  static async logout() {
    this.deleteAccessToken();
    this.deleteRefreshToken();
    return { success: true };
  }

  static async getMe() {
    const response = await this.get(this.userMeURL);
    const data = await response.json();
    return { data, response };
  }

  static async createUser(payload) {
    const response = await fetcher(this.userCreateURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return { data, response };

  }

  static async loginWithCode(email, code) {
    const response = await fetcher(this.loginWithCodeURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, code }),
    });
    const data = await response.json();
    return { data, response };
  }

  //   async verify(token) {
  //     return await axios.post(this.verifyURL, { token });
  //   }

  static setAccessToken(token) {
    return localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }

  static setRefreshToken(token) {
    return localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }

  static getAccessToken() {
    if (typeof window !== "undefined") {
      return localStorage.getItem(ACCESS_TOKEN_KEY);
    }
  }

  static getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  static deleteAccessToken() {
    return localStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  static deleteRefreshToken() {
    return localStorage.removeItem(REFRESH_TOKEN_KEY);
  }


  //   async localStorageTokenIsValid() {
  //     const token = this.getToken();
  //     return await this.verify(token);
  //   }

  static async get(url, params, cacheTime = null) {
    const headers = this.getAuthenticatedHeaders();
    const response = fetcher(url,
      {
        method: "GET",
        headers: headers
      },
      cacheTime
    );
    return response

  }

  static async put(url, payload, cacheTime = null) {
    const headers = this.getAuthenticatedHeaders()
    const response = fetcher(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(payload),
    }, cacheTime = null);
    return response;
  }

  static async patch(url, payload, cacheTime = null, format = 'json') {
    const headers = this.getAuthenticatedHeaders()
    let data;
    if (format === 'json') {
      headers['Content-Type'] = 'application/json'
      data = JSON.stringify(payload)
    }
    if (format === 'form') {
      delete headers['Content-Type']
      data = payload
    }
    const response = fetcher(url, {
      method: "PATCH",
      headers: headers,
      body: data,
    }, cacheTime = null);
    return response;
  }

  static async post(url, payload, cacheTime = null, format = 'json') {
    const headers = this.getAuthenticatedHeaders();
    let data;
    if (format === 'json') {
      headers['Content-Type'] = 'application/json'
      data = JSON.stringify(payload)
    }
    if (format === 'form') {
      delete headers['Content-Type']
      data = payload
    }

    const response = fetcher(url, {
      method: "POST",
      headers: headers,
      body: data,
    }, cacheTime = null);
    return response;
  }

  static getAuthenticatedHeaders() {
    const accessToken = this.getAccessToken();
    if (accessToken) {
      return {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      };
    }
    return {};
  }

  //   async doPut(url, payload) {
  //     const axios = await this.initializeAxiosInstance();
  //     const response = await axios.put(url, payload);
  //     return response;
  //   }

  //   async doPatch(url, payload) {
  //     const axios = await this.initializeAxiosInstance();
  //     const response = await axios.patch(url, payload);
  //     return response;
  //   }


  //   async doDelete(url) {
  //     const axios = await this.initializeAxiosInstance();
  //     const response = await axios.delete(url);
  //     return response;
  //   }

  //   createBaseAPIUrl(uri) {
  //     return `${this._getBaseURL()}/${this._getApiURL()}${uri}`;
  //   }

  //   async initializeAxiosInstance() {
  //     if (this._instance && this._instance.defaults.headers.common["Authorization"]) {
  //       return this._instance;
  //     }

  //     this._instance = axios.create({
  //       baseURL: `${this._getBaseURL()}/${this._getApiURL()}`,
  //     });

  //     if (typeof window !== "undefined") {
  //       const token = this.getToken();
  //       if (token) {
  //         this._instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  //       }
  //     }

  //     return this._instance;
  //   }

  arrayToObject(array) {
    return array.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  }


}

export { AuthenticationAPI }